<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h6 cl-primary">Dashboard</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-home</v-icon>
			<div class="pl-2 grey--text">Dashboard</div>
		</div>

		<!-- new dashboard -->
		<template v-if="!loading">
			<div class="mt-5">
				<v-row>
					<v-col cols="12" sm="12" md="12" v-if="upgradeData">
						<v-alert
							dense
							text
							type="error"
						>
							<p class="mb-0">Upgrade Khasanah Anda akan mulai berlaku pada tanggal <strong>{{ upgradeData.upgrade_log_date | tanggal }}</strong>.</p>
						</v-alert>
					</v-col>

					<v-col cols="12" sm="12" md="6" class="align-stretch" v-if="Object.values(myProfile).length > 0">
						<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
							<v-row>
								<v-col cols="12" class="d-flex flex-row align-center justify-space-between">
									<div class="font-size-12 cl-grey font-weight-500">Profil</div>
									<v-btn color="primary" small depressed class="text-capitalize rounded-xl font-weight-bold" @click="goProfile">
										Lihat Detail
									</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" sm="4" md="4" class="d-flex flex-column flex-stretch text-center justify-start align-center">
									<v-img height="120" width="120" class="user-img mx-auto rounded-pill hover-shadow" style="max-height: 120px;" :src="(myProfile.member_image_url) ? myProfile.member_image_url : '/assets/image/profile-pict.png'"></v-img>
									<div class="bottom-shadow"></div>
								</v-col>

								<v-col cols="12" sm="8" md="8">
									<div class="mb-4 font-size-13 font-weight-600 cl-primary">{{ myProfile.member_name }}</div>
									<v-row class="mb-3">
										<v-col cols="12" sm="6" md="6" v-if="myProfile.member_network_code">
											<div class="font-size-10 cl-grey">Kode Mitra</div>
											<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_network_code }}</div>
										</v-col>
										<v-col cols="12" sm="6" md="6">
											<div class="font-size-10 cl-grey">Tanggal Gabung</div>
											<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_join_datetime | tanggal }}</div>
										</v-col>
										<v-col cols="12" sm="6" md="6" v-if="!myProfile.member_network_code">&nbsp;</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-0 pt-md-1">
											<div class="font-size-10 cl-grey">Sponsor</div>
											<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_network_sponsor_network_code ? myProfile.member_network_sponsor_network_code : '-' }}</div>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-0 pt-md-1">
											<div class="font-size-10 cl-grey">Upline</div>
											<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_network_upline_network_code ? myProfile.member_network_upline_network_code : '-' }}</div>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-0 pt-md-1">
											<div class="font-size-10 cl-grey">Email</div>
											<div class="font-size-11 cl-grey font-weight-600" v-html="$options.filters.longText(myProfile.member_email, 20)"></div>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-0 pt-md-1">
											<div class="font-size-10 cl-grey">Nomor HP</div>
											<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_mobilephone ? myProfile.member_mobilephone : '-' }}</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
					<v-col cols="12" sm="12" md="6" v-if="Object.keys(memberBpjs).length > 0">
						<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height bpjs-card">
							<div class="text-right">
								<v-chip class="px-5 font-weight-bold white--text text-capitalize" :color=" memberBpjs.status_bpjs == 'aktif' ? 'green' : 'red'">{{ memberBpjs.status_bpjs }}</v-chip>
							</div>
							<div class="pb-md-5 font-size-12 cl-grey font-weight-500 text-center">BPJS Ketenagakerjaan</div>
							<div class="py-5 d-flex justify-center">
								<img height="auto" width="250" src="/assets/icon/bpjs-ketenagakerjaan.png">
							</div>
							<div class="pt-md-5 font-size-10 font-weight-500 teal--text text-center">Status Repeat Order Terakhir {{ memberBpjs.terakhir_ro | tanggal }}</div>
							<div class="pt-2 font-size-10 cl-grey text-center">Silakan melakukan RO setiap bulan agar status BPJS Ketenagakerjaan Anda selalu Aktif</div>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<div class="mt-3">
				<v-row>
					<v-col cols="12" sm="6" md="6" class="align-stretch">
						<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
							<div class="d-flex flex-wrap justify-space-between">
								<div class="font-size-12 cl-grey font-weight-500 my-auto">Kartu Mitra Usaha</div>
								<v-btn color="primary" depressed class="text-capitalize rounded-xl font-weight-bold" @click="goMitraCard">
									<v-icon small dark>mdi-text-box-search</v-icon>
									<span class="pl-2">Tampilkan</span>
								</v-btn>
							</div>
						</v-card>
					</v-col>
					<v-col cols="12" sm="6" md="6" class="align-stretch">
						<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
							<div class="d-flex flex-wrap justify-space-between">
								<div class="font-size-12 cl-grey font-weight-500 my-auto">Sertifikat Anda</div>
								<v-btn color="primary" depressed class="text-capitalize rounded-xl font-weight-bold" @click="goCertificate">
									<v-icon small dark>mdi-text-box-search</v-icon>
									<span class="pl-2">Tampilkan</span>
								</v-btn>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<div class="mt-3">
				<v-row>
					<v-scroll-x-reverse-transition mode="in-out">
						<v-col cols="12" sm="12" md="12" class="flex-stretch">
							<v-row>
								<v-col cols="12" sm="6" md="4">
									<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height" style="height: 340px">
										<div class="font-size-12 cl-grey font-weight-500 text-center">Total Komisi Diperoleh</div>
										<v-card-text class="px-0 d-flex flex-column justify-space-between fill-height">
											<div class="py-5">
												<v-img width="130" class="mx-auto my-5" style="height: auto; max-height: auto;" src="/assets/icon/coins.png"></v-img>
											</div>
											<div class="font-size-15 font-weight-bold cyan--text text--darken-1 text-center py-5">{{ summaryBonus.totalAcc | toRupiah }}</div>
										</v-card-text>
									</v-card>
								</v-col>

								<v-col cols="12" sm="6" md="4">
									<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
										<div class="font-size-12 cl-grey font-weight-500 text-center">Rincian Komisi</div>
										<div id="chart-rincian-komisi" class="fill-height py-4">
											<template v-if="summaryBonus.totalAcc == 0">
												<div class="empty-pie my-5" style="width:135px; height: 135px;"></div>
												<div class="font-size-10 grey--text text--darken-1 text-center">Belum ada rincian komisi yang dapat ditampilkan</div>
											</template>
											<template v-else>
												<apexchart type="pie" :options="rincianKomisi.chartOptions" :series="rincianKomisi.series" height="280"></apexchart>
											</template>
										</div>
									</v-card>
								</v-col>

								<v-col cols="12" sm="12" md="4" class="pa-0 d-flex flex-wrap">
									<v-col cols="12" sm="6" md="12" class="h-md-50">
										<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height teal lighten-2 white--text">
											<div class="font-size-12 font-weight-500">Total Komisi Dibayarkan</div>
											<div class="font-size-15 font-weight-bold text-left pt-2">{{ summaryBonus.totalPaid | toRupiah }}</div>
										</v-card>
									</v-col>
									<v-col cols="12" sm="6" md="12" class="h-md-50">
										<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height amber darken-2 white--text">
											<div class="font-size-12 font-weight-500">Total Saldo Komisi</div>
											<div class="font-size-15 font-weight-bold text-left pt-2">{{ summaryBonus.totalSaldo | toRupiah }}</div>
										</v-card>
									</v-col>
								</v-col>
							</v-row>
						</v-col>
					</v-scroll-x-reverse-transition>

					<v-scroll-x-reverse-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="flex-stretch" v-if="false">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height chart-komisi">
								<div class="font-size-12 cl-grey font-weight-500">Summary Komisi</div>
								<div id="chart-summary-komisi">
									<apexchart type="bar" height="380" :options="summaryKomisi.chartOptions" :series="summaryKomisi.series"></apexchart>
								</div>
							</v-card>
						</v-col>
					</v-scroll-x-reverse-transition>
				</v-row>
			</div>

			<!-- Downline -->
			<div class="mt-3">
				<v-row v-if="Object.keys(totalDownline).length > 0">
					<v-scroll-x-reverse-transition mode="in-out">
						<v-col cols="12" sm="6" md="6">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<v-row>
									<v-col cols="12">
										<div class="font-size-12 cl-grey font-weight-500 text-center">Total Downline</div>
									</v-col>
								</v-row>
								<v-row class="mt-0">
									<v-col cols="12" class=" text-center">
										<div class="font-size-25 font-size-xs-18 cl-primary font-weight-600">{{ totalDownline.total_downline | toNumber }}</div>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-reverse-transition>
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="3" md="3">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<v-row>
									<v-col cols="12">
										<div class="font-size-12 cl-grey font-weight-500 text-center">Downline Kiri</div>
									</v-col>
								</v-row>
								<v-row class="mt-0">
									<v-col cols="12" class=" text-center">
										<div class="font-size-20 font-size-xs-18 cl-secondary font-weight-600">{{ totalDownline.total_kiri | toNumber }}</div>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-transition>
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="3" md="3">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<v-row>
									<v-col cols="12">
										<div class="font-size-12 cl-grey font-weight-500 text-center">Downline Kanan</div>
									</v-col>
								</v-row>
								<v-row class="mt-0">
									<v-col cols="12" class=" text-center">
										<div class="font-size-20 font-size-xs-18 cl-secondary font-weight-600">{{ totalDownline.total_kanan | toNumber }}</div>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-transition>
				</v-row>
			</div>
			<!-- Downline -->

			<!-- Pertumbuhan Mitra -->
			<div class="mt-3">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-row>

							<!-- Pertumbuhan Mitra Minggu Ini -->
							<v-scroll-x-transition mode="in-out">
								<v-col cols="12" sm="6" md="7" v-if="memberGrowPerWeek.length > 0">
									<v-card class="pa-3 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
										<v-row>
											<v-col cols="12">
												<div class="pl-1 font-size-12 cl-grey font-weight-500">Pertumbuhan Mitra Minggu Ini</div>
											</v-col>
										</v-row>
										<v-row>
											<v-col cols="12">
												<div id="chart-netgrow">
													<template v-if="netGrow.series[0].data.length > 0">
														<apexchart type="area" height="350" :options="netGrow.chartOptions" :series="netGrow.series"></apexchart>
													</template>
													<template v-else>
														<div class="d-flex flex-column fill-height align-center justify-center pa-5">
															<v-icon color="grey" large>mdi-information-outline</v-icon>
															<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data pertumbuhan mitra yang ditampilkan.</div>
														</div>
													</template>
												</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-scroll-x-transition>
							<!-- Pertumbuhan Mitra Minggu Ini -->

							<!-- Registrasi Mitra Terbaru -->
							<v-scroll-x-transition mode="in-out">
								<v-col cols="12" sm="6" md="5" class="flex-stretch">
									<v-card class="pa-3 elevation-0 rounded-xl hover-shadow fill-height">
										<div class="pl-1 pb-4 font-size-12 cl-grey font-weight-500">Registrasi Mitra Terbaru</div>
										<template v-if="tenNewDownline.length > 0">
											<template v-if="tenNewDownline.length > 3">
												<carousel v-bind="slideSetting" id="memberSlide" :style="{height: '350px', overflow: 'hidden'}">
													<div v-for="downline in tenNewDownline" :key="downline.member_id">
														<div class="d-flex align-start justify-start mb-2 pb-0">
															<v-icon color="grey" size="36">mdi-account-circle-outline</v-icon>
															<div class="d-flex flex-column justify-start pl-5">
																<div class="d-block font-size-11 cl-primary font-weight-600">{{ downline.member_network_code }}</div>
																<div class="d-block font-size-11 cl-grey text-capitalize"><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
																<div class="d-block font-size-11 cl-grey font-weight-500 text-capitalize">{{ downline.member_city }}</div>
																<div class="d-block font-size-11 cl-grey">{{ downline.netgrow_node_date | haritanggal }}</div>
															</div>
														</div>
													</div>
												</carousel>
											</template>
											<template v-else>
												<v-row v-for="downline in tenNewDownline" :key="downline.member_id">
													<v-col cols="12" sm="12" md="12" class="d-flex align-start justify-start mb-1 pb-0">
														<v-icon color="grey" size="36">mdi-account-circle-outline</v-icon>
														<div class="d-flex flex-column justify-start pl-5">
															<div class="d-block font-size-11 cl-primary font-weight-600">{{ downline.member_network_code }}</div>
															<div class="d-block font-size-11 cl-grey text-capitalize"><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
															<div class="d-block font-size-11 cl-grey font-weight-500 text-capitalize">{{ downline.member_city }}</div>
															<div class="d-block font-size-11 cl-grey">{{ downline.netgrow_node_date | haritanggal }}</div>
														</div>
													</v-col>
												</v-row>
											</template>
										</template>
										<template v-else>
											<div class="d-flex flex-column fill-height align-center justify-center pa-5">
												<v-icon color="grey" large>mdi-information-outline</v-icon>
												<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data daftar downline yang ditampilkan.</div>
											</div>
										</template>
									</v-card>
								</v-col>
							</v-scroll-x-transition>
							<!-- Registrasi Mitra Terbaru -->

						</v-row>
					</v-col>
				</v-row>
			</div>
			<!-- Pertumbuhan Mitra -->

		</template>

		<template v-else>
			<loaderdashboard></loaderdashboard>
		</template>
		<!-- growth network summary -->

		<Announcement></Announcement>

	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import carousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import loaderDashboard from './components/loaderDashboard'
import Announcement from './components/Announcement'

export default {
	components: {
		apexchart: VueApexCharts,
		loaderdashboard: loaderDashboard,
		carousel,
		Announcement
	},
	data() {
		function formatRupiah(bilangan) {
			if (bilangan && bilangan >= 1000) {
				var	reverse = bilangan.toString().split('').reverse().join(''),
				ribuan 	= reverse.match(/\d{1,3}/g);
				ribuan	= ribuan.join('.').split('').reverse().join('');

				return ribuan;
			} else {
				return Number(bilangan.toFixed(2))
			}
		}

		function formatKomisLabel(label) {
			var	text = label.replace('Komisi', 'K. ').replace('Repeat Order', 'RO')
			return text;
		}

		return {
			loading: false,
			growthLoading: true,
			fiveDownline: '',
			loadUpgrade: false,
			upgradeData: null,
			kemitraan: [
			{
				type: 'pramitra',
				color: '#03bb5a',
				belanja: '0',
				badges: '',
				classText: 'mitra-pra'
			},
			{
				type: 'silver',
				color: '#688389',
				belanja: '1.300.000',
				badges: '/assets/icon/silver.svg',
				classText: 'mitra-silver'
			},
			{
				type: 'gold',
				color: '#6e490f',
				belanja: '3.900.000',
				badges: '/assets/icon/gold.svg',
				classText: 'mitra-gold'
			},
			{
				type: 'diamond',
				color: '#2a4fd6',
				belanja: '13.000.000',
				badges: '/assets/icon/diamond.svg',
				classText: 'mitra-diamond'
			}
			],

			summaryKomisi: {
				series: [{
					name: 'Komisi',
					data: []
				}, {
					name: 'Dibayarkan',
					data: []
				}, {
					name: 'Saldo',
					data: []
				},],
				chartOptions: {
					chart: {
						type: 'bar',
						height: 500
					},
					plotOptions: {
						bar: {
							horizontal: true,
							dataLabels: {
								position: 'top',
							},
						}
					},
					dataLabels: {
						enabled: false,
						offsetX: -6,
						style: {
							fontSize: '9px',
							colors: ['#fff']
						},
						background: {
							padding: 6
						},
						formatter: function(value) {
							if(value != undefined) return formatRupiah(value);
						}
					},
					stroke: {
						show: true,
						colors: ['#fff']
					},
					tooltip: {
						shared: true,
						intersect: false,
						y: {
							formatter: function(value) {
								if(value != undefined) return 'Rp ' + formatRupiah(value);
							}
						},
					},
					xaxis: {
						categories: [],
						labels: {
							formatter: function(value) {
								if(value != undefined) return formatRupiah(value);
							}
						}
					},
				},
			},

			rincianKomisi: {
				series: [],
				chartOptions: {
					chart: {
						size: '120%'
					},
					colors: ['#4db6ac', '#feb019', '#d2dc46'],
					labels: [],
					responsive: [{
						breakpoint: 480,
						options: {
							chart: {
								width: '100%',
								height: 350
							},
							legend: {
								position: 'bottom'
							}
						}
					}],
					legend: {
						position: 'bottom',
						fontSize: 9,
						formatter: function(seriesName, opts) {
							return [ '<span>' + formatKomisLabel(seriesName) + '</span>', '<span class="font-weight-bold">Rp ' + formatRupiah(opts.w.globals.series[opts.seriesIndex]) + '</span>']
						}
					},
					tooltip: {
						y: {
							formatter: function(value) {
								if(value != undefined) return 'Rp ' + formatRupiah(value);
							}
						}
					},
				},
			},

			netGrow: {
				series: [
				{
					name: 'Registrasi',
					data: []
				}, {
					name: 'Aktivasi',
					data: []
				}
				],

				chartOptions: {
					colors: ['#3CB7BF', '#F06324'],
					chart: {
						width: '100%',
						height: 350,
						type: 'area'
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						curve: 'smooth'
					},
					xaxis: {
						type: 'datetime',
						categories: []
					},
					yaxis: {
						labels: {
							formatter: function(val) {
								return val
							}
						}
					},
					tooltip: {
						x: {
							format: 'dd MMM yyyy'
						},
					},
				},
			},
			slideSetting: {
				'dots': true,
				'arrows': false,
				'infinite': true,
				'slidesToShow': 4,
				'slidesToScroll': 2,
				'vertical': true,
				'autoplay': true,
				'verticalSwiping': true
			},
		}
	},
	computed: {
		...mapState('profile', ['myProfile']),
		...mapState('dashboard', ['memberBpjs', 'summaryBonus', 'memberGrowPerWeek', 'totalDownline', 'tenNewDownline',]),
	},
	methods: {
		...mapActions('profile', ['getProfileMitra', 'getUpgradeStatus']),
		...mapActions('dashboard', ['getMemberBpjs', 'getSummaryBonus', 'getMemberGrowPerWeek', 'getTotalDownline', 'getTenNewDownline',]),

		cekUpgradeStatus() {
			this.loadUpgrade = true
			this.getUpgradeStatus().then((res) => {
				this.upgradeData = res.results.data
			}).catch(() => {
				this.upgradeData = null
			})

			setTimeout(() => {
				this.loadUpgrade = false
			}, 1000);
		},

		goProfile() {
			this.$router.push({name: 'profil'})
		},
		goMitraCard() {
			let routeData = this.$router.resolve({name: 'kartu-mitra'})
			window.open(routeData.href, '_blank');
		},
		goCertificate() {
			let routeData = this.$router.resolve({name: 'sertifikat'})
			window.open(routeData.href, '_blank');
		},

		setDataRincianKomisi(data) {
			this.rincianKomisi.series = data.map((el) => el['acc'])
			this.rincianKomisi.chartOptions.labels = data.map((el) => el['label'])
			const labels = data.map((el) => el['label'])
			for (let i = 0; i < labels.length; i++) {
				this.summaryKomisi.chartOptions.xaxis.categories.push(labels[i].replace('Komisi', '').replace('Repeat Order', 'RO'))
			}
			this.summaryKomisi.series[0].data = data.map((el) => el['acc'])
			this.summaryKomisi.series[1].data = data.map((el) => el['saldo'])
			this.summaryKomisi.series[2].data = data.map((el) => el['paid'])
		},

		async setMemberGrowPerWeek(data) {
			this.netGrow.series[0].data = await data.map((el) => parseInt(el['member_registration']))
			this.netGrow.series[1].data = await data.map((el) => parseInt(el['member_activation']))
			this.netGrow.chartOptions.xaxis.categories = await data.map((el) => el['member_date'])
		},

		async getData() {
			this.loading = await true
			await this.getProfileMitra()
			await this.getMemberBpjs()
			await this.getSummaryBonus()
			await this.setDataRincianKomisi(this.summaryBonus.arrKomisi)
			await this.getTotalDownline()
			await this.getMemberGrowPerWeek().then(() => {
				if (this.memberGrowPerWeek) {
					this.setMemberGrowPerWeek(this.memberGrowPerWeek)
				}
			})
			await this.getTenNewDownline()

			setTimeout(() => {
				this.loading = false
				this.growthLoading = false
			}, 300)
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Dashboard`)
		this.getData()
		this.cekUpgradeStatus()
	}
};
</script>